/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/layout'

// 民宿旅游
const router = {
  path: '/hotel',
  component: Layout,
  children: [
    {
      path: '/hotel',
      name: 'hotel',
      meta: {
        title: '民宿旅游',
      },
      component: () => import('@/views/hotel/home.vue'),
    },
  ],
}

export default router
